import { BetSlipTypes } from "@gp/models";
import BetSlipStore from "@state/bet-slip/BetSlipStore";
import { getCurrentCulture } from "@utils";

const MAX_EVENTS = 10;

function getEventIdForShare(eventId: string): string {
	if (eventId.startsWith("multiBet-")) {
		return eventId.split("-")[1];
	}
	return eventId;
}

function getTipIdForShare(tipId: string): string {
	if (tipId.startsWith("multiBet-")) {
		return tipId.split("-")[1];
	}
	return tipId;
}

function getBaseUrl() {
	let baseUrl = `${WEBPACK_DESKTOP_WEBSITE_URL}/${getCurrentCulture()}`;

	baseUrl += `/sports/full`;

	return baseUrl;
}

export function useBetSlipCurrentShareUrl(store: BetSlipStore) {
	const baseUrl = getBaseUrl();

	const tipsArray = store.betSlipState.clickedTips
		.slice(0, MAX_EVENTS)
		.map((tip: any) => {
			const eventId = getEventIdForShare(tip.eventId);
			const tipId = getTipIdForShare(tip.id);
			const isBank = tip.isBank;
			const value = tip.value;

			if (tip.multiOffers && tip.multiOffers.length > 0) {
				return [
					eventId,
					tipId,
					...(isBank ? ["bank"] : []),
					"bb",
					...tip.multiOffers.map(
						(o: any) => `${o.multiOfferId}-${o.value ?? 0}`
					),
					value,
				].join("|");
			} else {
				return [
					eventId,
					tipId,
					...(isBank ? ["bank"] : []),
					value,
				].join("|");
			}
		});

	return function buildShareUrl() {
		const urlParams = new URLSearchParams();

		tipsArray.forEach((tipStr) => {
			urlParams.append("tip", tipStr);
		});

		if (store.betSlipType === BetSlipTypes.SYSTEM) {
			urlParams.set("type", `"system"`);
		}

		const system = store.betSlipState.slip.system;

		if (system !== null && system !== undefined) {
			urlParams.set("system", String(system));
		}

		return `${baseUrl}?${urlParams.toString()}`;
	};
}
